export default __webpack_public_path__ + "static/media/Amortisation-declining.ebb057f3.svg";